import {
  FORM_STUDIO_DEFAULT_SECTION,
  FORM_STUDIO_SECTIONS,
} from '../constants/formStudioConfig';

const SECTION_VALUES = new Set(FORM_STUDIO_SECTIONS.map(({ value }) => value));

/** Sections that require a persisted form id before they can be opened. */
export const FORM_STUDIO_LOCKED_BEFORE_SAVE_SECTIONS = new Set([
  'automations',
  'assets',
]);

export function isFormStudioSectionLocked(section, hasFormId) {
  if (hasFormId) {
    return false;
  }
  return FORM_STUDIO_LOCKED_BEFORE_SAVE_SECTIONS.has(
    normalizeFormStudioSection(section)
  );
}

export function normalizeFormStudioSection(section) {
  const normalized = String(section || '').trim().toLowerCase();
  if (normalized === 'workflow') {
    return 'fields';
  }
  return SECTION_VALUES.has(normalized) ? normalized : FORM_STUDIO_DEFAULT_SECTION;
}

export function getFormStudioSection(section) {
  const normalized = normalizeFormStudioSection(section);
  return FORM_STUDIO_SECTIONS.find(({ value }) => value === normalized);
}
